<template>
  <section ref="root" class="dc-container">
    <!-- papel rasgado -->
    <div class="rasgado rasgado-top"></div>

    <!-- CONTENIDO -->
    <div class="dc-card">
      <!-- Título en dos líneas -->
      <h2 ref="title" class="dc-title">
        <span>Dress</span><br />
        <span class="script">Code</span>
      </h2>

      <!-- Etiqueta -->
      <div ref="badge" class="dc-badge">FORMAL</div>

      <!-- Ilustración vestido / traje -->
      <img
        ref="figure"
        src="@/assets/codigo.png"
        alt="Dress code"
        class="dc-figure"
      />

      <!-- Nota -->
      <p ref="note" class="dc-note">
        We reserve the Baby Blue color for the Celebrant <br>
      </p>
    </div>

    <div class="rasgado rasgado-bottom"></div>
  </section>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'DressCodeLuxuryExact',
  setup() {
    const root = ref(null)
    const title = ref(null)
    const badge = ref(null)
    const figure = ref(null)
    const note = ref(null)

    onMounted(async () => {
      await nextTick()

      if (!root.value) return

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: root.value,
          start: 'top 85%', 
          once: true
        }
      })

      // Animación de Entrada Elegante
      tl.from(title.value, {
        opacity: 0,
        y: 40,
        filter: 'blur(15px)',
        duration: 1.2,
        ease: 'power4.out'
      })
      .from(badge.value, {
        opacity: 0,
        scale: 0.9,
        y: 20,
        duration: 0.8,
        ease: 'power3.out'
      }, "-=0.8") // Empieza antes de que termine el título
      .from(figure.value, {
        opacity: 0,
        scale: 0.8,
        y: 30,
        duration: 1,
        ease: 'expo.out'
      }, "-=0.6")
      .from(note.value, {
        opacity: 0,
        y: 15,
        duration: 0.8,
        ease: 'power2.out'
      }, "-=0.5")
    })

    onUnmounted(() => {
      ScrollTrigger.getAll().forEach(t => t.kill())
    })

    return { root, title, badge, figure, note }
  }
}
</script>

<style scoped>
.dc-container {
  position: relative;
  max-width: 500px;
  margin: 0 auto;
  background: #8fbbdf;
  padding: 80px 18px 80px; /* Más espacio vertical para elegancia */
  overflow: hidden;
  text-align: center;
}

/* Rasgados */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 45px;
  background: #ffffff; 
  z-index: 1;
  pointer-events: none;
}
.rasgado-top {
  top: -1px;
  clip-path: polygon(0% 70%, 15% 50%, 35% 80%, 55% 50%, 75% 75%, 100% 55%, 100% 0%, 0% 0%);
}
.rasgado-bottom {
  bottom: -1px;
  clip-path: polygon(0% 30%, 15% 50%, 35% 20%, 55% 50%, 75% 25%, 100% 45%, 100% 100%, 0% 100%);
}

.dc-card {
  position: relative;
  z-index: 2;
}

.dc-title {
  font-family: 'britishgruesa', cursive;
  font-size: 68px;
  color: #ffffff;
  margin: 0 0 20px;
  line-height: 0.95;
  letter-spacing: -1px;
  text-shadow: 0 4px 12px rgba(0,0,0,0.08);
}
.dc-title .script {
  font-weight: 400;
  opacity: 0.95;
}

.dc-badge {
  display: inline-block;
  background: #ffffff;
  color: #5b7da1; 
  font-family: 'padres', sans-serif;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.25em;
  padding: 12px 30px;
  border-radius: 50px; 
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  margin: 10px 0 25px;
  text-transform: uppercase;
}

.dc-figure {
  width: 190px;
  height: auto;
  display: block;
  margin: 20px auto;
  filter: drop-shadow(0 15px 25px rgba(0, 0, 0, 0.15));
}

.dc-note {
  font-family: 'quote', serif;
  font-size: 17px;
  color: #ffffff;
  opacity: 0.95;
  font-style: italic;
  margin-top: 20px;
  line-height: 1.5;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
}

@media (max-width: 480px) {
  .dc-title { font-size: 52px; }
  .dc-container { padding: 60px 15px; }
  .dc-figure { width: 160px; }
}
</style>